import React from "react";

import AddIcon from "@mui/icons-material/Add";

import { ButtonVariant } from "Constant/button";

import { getDestinationIconByCode } from "helpers/destinations/getDestinationIcon";

import StandartButton from "components/atoms/StandartButton";

import SelectableList from "../../components/SelectableList";
import StepHeader from "../../components/StepHeader";
import { wizardButtonSx } from "../../SignalWizard.styled";

const getIcon = (destination) =>
    getDestinationIconByCode(destination?.destination_type?.code);

const DestinationsStep = ({
    language,
    isDestinationForcedByTemplate,
    destinations,
    isDestinationsLoading,
    selectedDestinations,
    isDestinationAvailable,
    onToggleDestination,
    onDeleteDestination,
    onAddDestination,
}) => {
    const addLabel =
        language?.tracker_wizard?.add_destination ?? "Add Destination";

    return (
        <>
            <StepHeader
                language={language}
                stepNumber={2}
                title={
                    language?.tracker_wizard?.select_your_destinations ??
                    "Select your destinations"
                }
                description={
                    language?.tracker_wizard
                        ?.your_target_endpoint_where_data_is_sent_for_analysis_and_action_such_as_ad_platforms_or_marketing_analytics_tools ??
                    "Your target endpoint where data is sent for analysis and action, such as ad platforms or marketing analytics tools."
                }
                helpText={
                    language?.tracker_wizard
                        ?.increase_your_reach_and_insights_by_connecting_to_multiple_destinations_for_wider_distribution_and_utilization_of_your_data ??
                    "Increase your reach and insights by connecting to multiple destinations for wider distribution and utilization of your data."
                }
                actionLabel={addLabel}
                onAction={onAddDestination}
                actionTestId="create-destination-add"
            />

            {!isDestinationForcedByTemplate && (
                <SelectableList
                    language={language}
                    items={destinations}
                    typeKey="destination_type"
                    getIcon={getIcon}
                    isSelected={(destination) =>
                        selectedDestinations.includes(+destination.id)
                    }
                    onToggle={onToggleDestination}
                    isItemDisabled={(destination) =>
                        !isDestinationAvailable(destination)
                    }
                    disabledTooltip={
                        language?.tracker_wizard?.destination_not_available ??
                        "Not available for the selected sources"
                    }
                    onDelete={onDeleteDestination}
                    inUseTooltip={
                        language?.tracker_wizard?.destination_in_use ??
                        "Destination is already in use!"
                    }
                    sectionTitle={
                        language?.tracker_wizard?.configured_destinations ??
                        "Configured destinations"
                    }
                    searchPlaceholder={
                        language?.tracker_wizard?.filter_destinations ??
                        "Filter destinations by name or type..."
                    }
                    emptyTitle={
                        language?.tracker_wizard?.no_destinations_yet ??
                        "No destinations yet"
                    }
                    emptyDescription={
                        language?.tracker_wizard?.create_first_destination ??
                        "Create a destination to choose where your events are sent."
                    }
                    emptyAction={
                        <StandartButton
                            variant={ButtonVariant.BLACK_OUTLINED}
                            onClick={onAddDestination}
                            startIcon={<AddIcon />}
                            sx={wizardButtonSx}
                        >
                            {addLabel}
                        </StandartButton>
                    }
                    isLoading={isDestinationsLoading}
                    itemTestId="wizard-destination-item"
                />
            )}
        </>
    );
};

export default DestinationsStep;
